import * as ko from "knockout";
import { ApplicationIds } from "../../../core/application-ids";
import BaoDialogViewModel from "../../factories/bao-dialog";
import { TenantSwitcher } from "../../factories/tenant-switcher/tenant-switcher";
import Bao from "../../services/bao-service";
import RequestResetPassword from "../../view-models/bao-dialog/request-reset-password";
import { PasswordChanger } from "./../../factories/password-changer/password-changer";
import template from "./login-page.html";
import { UserManager } from "oidc-client";

export class LoginPage {

    public get CaptionNoConnection() {
        switch (this.LanguageSymbol()) {
            case "de-DE":
                return "Keine Verbindung zum Server";
            default:
                return "No connection to the server";
        }
    }

    public NewDesign = ko.observable(false);
    public IsLoading = ko.observable(false);
    public LanguageSymbol = ko.observable("");
    public Password = ko.observable("");
    public Username = ko.observable("");
    public CurrentVersion = ko.observable("7.0.0");
    public CaptionUsername = ko.observable("Username");
    public CaptionPassword = ko.observable("Password");
    public CaptionLanguage = ko.observable("Language");
    public CaptionLogin = ko.observable("");
    public CaptionAutoLogin = ko.observable("");
    public CaptionRequestPassword = ko.observable("forgot password?");
    public CaptionEnableRegisterUser = ko.observable("");
    public CaptionADAuth = ko.observable("");
    public CaptionOk = ko.observable("Ok");
    public LanguageList = ko.observableArray<{ Caption: string, Symbol: string }>([]);
    public MandatorActive = ko.observable(false);
    public ADAuth = ko.observable(true);
    public ADAuthEnabled = ko.observable(false);
    public KeycloakEnabled = ko.observable(false);
    public CookiesEnabled = ko.observable(false);
    public EnableRegisterUser = ko.observable(false);
    public EnableForgotPassword = ko.observable(false);
    public FormVisible = ko.observable(true);
    public CompanyName = ko.observable("");
    public CompanyUrl = ko.observable("");
    public CompanyText = ko.observable("");
    public ApplicationId = ko.observable();
    public ApplicationIds = ApplicationIds;
    public MandatorId: string = "";
    public ApplicationName = ko.observable();

    public ADAuthActive = ko.pureComputed(() => {
        return this.ADAuth() == true && this.ADAuthEnabled() == true;
    });
    public Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName());

    private subscriptions: KnockoutSubscription[] = [];

    private manager;

    constructor(private callback: () => void) {
        Bao.get("Login/GetKeycloakConfig", (options) => {
            if (options.Authority) {
                this.manager = new UserManager({
                    authority: options.Authority,
                    client_id: options.ClientId,
                    redirect_uri: options.RedirectUri,
                    response_type: options.ResponseType,
                    scope: options.Scope
                });
                this.KeycloakEnabled(true)
            }
        }).then(() => {
            this.subscriptions.push(this.ADAuthActive.subscribe((newValue) => {
                this.Username("");
                if (newValue == true) {
                    this.GetADName();
                    this.Password("");
                }
            }));

            this.subscriptions.push(this.Password.subscribe((newValue) => {
                if (this.ADAuthActive() == true && newValue != "") {
                    this.Password("");
                }
            }));

            this.Dialog.Buttons([new BaoDialogViewModel.ButtonFactory(this.Dialog, this.CaptionOk)]);
            this.Dialog.Width("400px");
            this.Dialog.VerticalMode("middle");
        });

        let captionDeferred;
        this.subscriptions.push(this.LanguageSymbol.subscribe(() => {
            localStorage.languageSymbol = this.LanguageSymbol();
            this.IsLoading(true);
            if (captionDeferred != null && captionDeferred.abort != undefined) {
                captionDeferred.abort();
            }
            captionDeferred = Bao.Session.GetCaptions("Login", this.LanguageSymbol()).then((captions) => {
                this.CaptionUsername(captions.lblUsername);
                this.CaptionPassword(captions.lblPassword);
                this.CaptionLanguage(captions.lblLanguage);
                this.CaptionAutoLogin(captions.lblAutoLogin);
                this.CaptionRequestPassword(captions.lblRequestPassword);
                this.CaptionEnableRegisterUser(captions.lblRegisterUser);
                this.CaptionLogin(captions.btnLogin);
                this.CaptionADAuth(captions.lblADAuth);
                this.CaptionOk(captions.btnOk);
                this.IsLoading(false);
            });
        }));
    }

    public RequestResetPassword() {
        const d = new RequestResetPassword(this.LanguageSymbol(), this.Username());
    }

    public SingleSignOn(force?) {
        const def = $.Deferred();
        if (force == true || String(this.getParam("mode")).toLowerCase().indexOf("logout") === -1) {
            this.IsLoading(true);
            const languageSymbol = "";
            if (force == true) {
                const languageSymbol = this.LanguageSymbol();
            }
            return Bao.post("Login/SingleSignOn", JSON.stringify({
                languageSymbol: languageSymbol
            })).then((result) => {
                if (result === true) {
                    this.SelectTenant();
                }
            }).always(() => {
                def.resolve();
            });
        } else {
            def.resolve();
        }
        return def.promise();
    }

    public Login() {
        if (this.ADAuthActive()) {
            this.SingleSignOn(true);
        } else {
            this.IsLoading(true);
            this.IsAlreadyLoggedUserInTheBrowser()
                .then(result => {
                    if (result) {
                        return;
                    }

                    Bao.post("Login/Login", JSON.stringify({
                        loginModel: ko.map.toJS(this)
                    }), (value) => {
                        if (value.Result == true) {
                            this.removeParam('mode');
                            this.SelectTenant();
                        } else {
                            this.IsLoading(false);
                            if (value.Id == "UserMustChangePassword") {
                                this.ChangePassword();
                            } else {
                                this.Password("");
                                this.Dialog.Template(value.Message);
                                this.Dialog.Open();
                                this.Dialog.Closed = () => {
                                    this.UserFocus();
                                };
                            }
                        }
                    }).fail(() => {
                        this.IsLoading(false);
                        this.Dialog.Template(this.CaptionNoConnection);
                        this.Dialog.Open();
                        this.Dialog.Closed = () => {
                            this.UserFocus();
                        };
                    });
                });
        }
    }

    public LoginViaKeycloak() {
        this.manager.signinRedirect()
            .then(() => { });
    }

    public SelectTenant() {
        this.IsLoading(true);
        this.SetMandatorId().then(_ => {
            if (this.MandatorActive()) {
                const tenantSwitcher = new TenantSwitcher();
                tenantSwitcher.LanguageSymbol = this.LanguageSymbol();
                tenantSwitcher.Open().then((result) => {
                    if (result) {
                        this.callback();
                    } else {
                        this.UserFocus();
                    }
                });
            } else {
                this.callback();
            }
        });
    }

    public UserFocus() {

    }

    public dispose() {
        this.IsLoading(false);
    }

    public getParam(variable) {
        const url = new URL(window.location.href);
        let param;
        url.searchParams.forEach((value, key) => {
            if (key.toLowerCase() === variable)
                param = value;
        })

        return param ?? false;
    }

    public removeParam(variable) {
        const url = new URL(window.location.href);
        url.searchParams.forEach((value, key) => {
            if (key.toLowerCase() === variable)
                url.searchParams.delete(key);
        })
        
        history.replaceState(null, null, url.href);
    }

    public init() {

        this.IsLoading(true);

        return Bao.postSync({ url: "Login/GetLoginModel" })
            .then((result) => {
                this.IsLoading(false);
                ko.map.fromJS(result, this);
                $("title").text(this.ApplicationName())
                let language:any = this.LanguageList().find((lang:any) => lang.IsDefault());

                if (localStorage.languageSymbol == undefined && language) {
                    localStorage.languageSymbol = language.Symbol();
                    this.LanguageSymbol(localStorage.languageSymbol);
                } else if (localStorage.languageSymbol)
                        this.LanguageSymbol(localStorage.languageSymbol);

                if (result.Theme != undefined) {
                    let body = document.getElementsByTagName("body")[0];
                    body.classList.add(result.Theme.trim().toLowerCase());
                }
            }).fail(() => {
                this.IsLoading(false);
            });


    }

    public loaded() {
        this.SingleSignOn()
            .always(() => this.IsLoading(false));
    }

    private ChangePassword() {
        if (typeof this.LanguageSymbol() === "undefined") {
            this.LanguageSymbol(Bao.Session.Language.Symbol());
        }
        const passwordChanger = new PasswordChanger();
        passwordChanger.LanguageSymbol(this.LanguageSymbol());
        passwordChanger.Username(this.Username());
        passwordChanger.OldPassword(this.Password());
        passwordChanger.Open().then((result) => {
            if (result) {
                this.SelectTenant();
            } else {
                this.UserFocus();
            }
        });
    }

    private GetADName() {
        Bao.post("Login/GetADName", (value) => {
            this.Username(value);
        });
    }

    /*
     * Returns true if a user is logged into the browser and displays the message
     * */
    private IsAlreadyLoggedUserInTheBrowser(): JQueryPromise<boolean> {
        return Bao.Session.RenewSession()
            .then(result => {
                if (result) {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessageBySymbol("msgAlreadyLoggedUserInTheBrowser", this.LanguageSymbol()), "info");
                    this.IsLoading(false);
                    return true;
                }
                return false;
            });
    }

    private SetMandatorId(): JQueryPromise<boolean> {
        let mandatorid = this.getParam("mandatorid");
        if (mandatorid) {
            this.MandatorId = mandatorid.split('/')[0];
            this.removeParam('mandatorid');
            return Bao.post("Login/SetMandator", JSON.stringify({
                mandatorId: this.MandatorId
            }));
        }
        else {
            this.IsLoading(false);
            return $.Deferred().resolve(false).promise();
        }
    }
}

export default {
    viewModel: {
        createViewModel: function (params, componentInfo) {
            const e = componentInfo.element;
            let vm: LoginPage = null;
            ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
                if (vm != null) {
                    vm.dispose();
                }
            });
            vm = new LoginPage(params.callback);
            vm.init().then(_ => { vm.loaded(); });
            return vm;
        }
    },
    template: template
};
